import { ConversationMessage, IMessage } from "@/core/entities/conversation";
import { IConversationRepository, PostConversationMessageParams } from "@/core/repositories/conversation";

export class SendMessageUseCase {
  constructor(private readonly conversationRepository: IConversationRepository) {}

  async execute(params: PostConversationMessageParams): Promise<IMessage> {
    const result = await this.conversationRepository.postConversationMessage(params);

    return new ConversationMessage(result.postMessage);
  }
}
